import { Link } from "react-router-dom"
import { useAuth } from "../services/AuthProvider"

export const Logout:React.FC = ()=>{
  const {currentUser, logout} = useAuth();
  return currentUser? <Link to="splash" onClick={()=>{logout()}}>Logout</Link> : <Link to="home">Login</Link>
}